/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useState, useRef, useCallback } from 'react';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import { connect,useDispatch } from 'react-redux';
import { withRouter } from 'react-router';
import classes from './CalculatedSensor.module.css';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import BobConfirmButton from '../../../components/BobConfirmButton';
import FormControl from '@material-ui/core/FormControl';
import {isEmpty, debounce, startsWith, cloneDeep } from 'lodash';
import TextField from '@material-ui/core/TextField';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { Grid, GridColumn} from '@progress/kendo-react-grid';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { getter } from '@progress/kendo-react-common';
import AutoComplete  from '@material-ui/lab/Autocomplete';
import AutoComplete1 from '../../../components/FormFields/Autocomplete';
import * as ArchitectActions from '../../../actions/architectActions';
import * as ApplicationMessageActions from '../../../actions/applicationMessageActions';
import * as BasAgentActions from '../../../actions/basAgentActions';
import * as DeviceActions from '../../../actions/deviceActions';
import * as UiActions from '../../../actions/uiActions';
import * as SensorTypeActions from '../../../actions/sensorTypeActions';
import * as reportingActions from '../../../actions/reportingActions';
import * as BobActions from '../../../actions/bobActions';
import * as DashboardActions from '../../../actions/dashboardActions';
import * as EquipmentTypeActions from '../../../actions/equipmentTypeActions';
import * as K2ACoreActions from '../../../actions/k2aCoreActions';
import queryString from 'query-string';
import { enqueueSnackbar } from '../../../actions/applicationMessageActions';
import NoSelectedSensorsScreen from '../../../components/NoSelectedSensorsScreen';
import * as WizardActions from '../../../actions/wizardActions';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import { parse } from 'url-template';
import { fetchEquipmentTypesLookup } from '../../../actions/lookupActions';
import Popper from '@material-ui/core/Popper';
import BobModal from '../../../components/BobModal';
import { ClickAwayListener } from '@material-ui/core';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Paper from '@material-ui/core/Paper';
import InputAdornment from '@material-ui/core/InputAdornment';
import CircularProgress from '@material-ui/core/CircularProgress';
import classes1 from './FormulaBuilder.module.css';
import Button from '@material-ui/core/Button';
import Popover from '@material-ui/core/Popover';
import Tooltip from '@material-ui/core/Tooltip';
import BobWorkbookModeButton from '../../../components/BobWorkbookModeButton';
import BobLoadingMask from '../../../components/BobLoadingMask';

const idGetter = getter('processId');

const AssignForm = ({
    activeNavClient,
    activeNavCompany,
    activeNavEquipment,
    activeNavSite,
    agents,
    bobLoading,
    collectTargetSensors,
    configEntities,
    createBulkSensors,
    dashboardBulkComplete,
    entitySensors,
    equipment,
    equipmentTypes,
    fetchConfigEntitesBySiteId,
    fetchCoreEquipment,
    fetchEntitySensors,
    fetchEquipmentTypesLookup,
    fetchReportSensorsbyEquipment,
    fetchSensorCalculations,
    fetchSensorTemplate,
    fetchSensorTypes,
    fetchTemplateDetails,
    history,
    navSites,
    sensorCalculations,
    sensorErrorObj,
    sensorsCreatedEvent,
    sensorTemplate,
    sensorTypes,
    setBulkSensorCreateComplete,
    setWorkBookMode,
    units,
    workbookModeEnabled,
    ...props
}) => {
    const dispatch = useDispatch();
    const [templates, setTemplates] = useState(['Template1','Template2']);
    const [displayUnitTypeDisabled, setDisplayUnitTypeDisabled] = useState(true);
    const [unitTypeDisabled, setUnitTypeDisabled] = useState(false);
    const [equipment1Types, setEquipment1Types] = useState([]);
    const [displayUnits, setDisplayUnits] = useState([]);
    const [activeDisplayUnit, setActiveDisplayUnit] = useState({});
    const [activeTemplate,setActiveTemplate] = useState({});
    const [selectedSensorTemplate, setSelectedSensorTemplate] = useState({});
    const [filteredEquipments,setFilteredEquipments] = useState([]);
    const [filteredSensorTypes,setFilteredSensorTypes] = useState([]);
    const [externalSensorOpen,setExternalSensorOpen] = useState(false);
    const [entities, setEntities] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [selectAll,setSelectAll] = useState(false);
    const [selectAllV,setSelectAllV] = useState(false);
    const [displayToken,setDisplayToken] = useState('');
    const [selectedState, setSelectedState] = useState({});
    const [anchorEl1, setAnchorEl1] = useState(null);
    const [menuOpen, setMenuOpen] = useState(false);
    const [anchorEl2, setAnchorEl2] = useState(null);
    const [menuOpen2, setMenuOpen2] = useState(false);
    const [anchorEl3, setAnchorEl3] = useState(null);
    const [menuOpen3, setMenuOpen3] = useState(false);
    const [selectedEntity, setSelectedEntity] = useState({});
    const [sensorList, setSensorList] = useState([]);
    const [sensorListBase, setSensorListBase] = useState([]);
    const [displayDataTypes, setDisplayDataTypes] = useState(['Boolean','Integer','Float','Text']);
    const [operatorList, setoperatorList] = useState(['Contains','Does not Contain','Is equal to','Is not equal to','Starts with','Ends with']);
    const [filterop, setFilterop] = useState('');
    const [filteropClient, setFilteropClient] = useState('');
    const [filteropSite, setFilteropSite] = useState('');
    const [statusList, setStatusList] = useState(['Assigned','Unassigned']);
    const [editorVisible,setEditorVisible] = useState(false);
    const [checkedList,setCheckedList] = useState([]);
    const [anchorEl, setAnchorEl] = useState(null);
    const [autoCompleteValue, setAutoCompleteValue] = useState('');
    const [filteredExtSensorTypes,setFilteredExtSensorTypes] = useState([]);
    const [esensors,setEsensors] = useState([]);
    const [loading, setLoading] = useState(false);
    const [eqFilter, setEqFilter] = useState('');
    const [clientFilter, setClientFilter] = useState('');
    const [siteFilter, setSiteFilter] = useState('');
    const [bulkCreateSubmittedTime, setBulkCreateSubmittedTime] = useState(Math.floor(Date.now() / 1000));
    const extSensor = useRef(null);
    const extSensorIndex = useRef(null);
    let filterTimer;
    const [assignList, setAssignList] = useState([
        {equipment: '3434', status: 'Assigned',sensorName: 'Sensor ABC', client: 'Client', site: 'Site', sensorA: '3434', sensorB: '3434', value: 'Enter'}, 
        {equipment: '3434', status: 'Assigned',sensorName: 'Sensor ABC', client: 'Client', site: 'Site', sensorA: '3434', sensorB: '3434', value: 'Enter'},
        {equipment: '3434', status: 'Assigned',sensorName: 'Sensor ABC', client: 'Client', site: 'Site', sensorA: '3434', sensorB: '3434', value: 'Enter'}
    ]);

    const ValidationSchema = Yup.object().shape({
        template: Yup.string()
            .required()
    });

    let formVal = {
        initialValues: {
            template:              '',
            equipmentType:         '',
            site:                  activeNavSite ? activeNavSite.id : '',
            equipmentTypeSelected: '',
            equipment:             ''

        },
        validationSchema:   ValidationSchema,
        enableReinitialize: true,
        onSubmit:           async (values, { setSubmitting }) => {

        }

    };
    const queryValues = queryString.parse(history.location.search);
    
    useEffect(() => {
        setEquipment1Types([...equipmentTypes]);
        if (activeNavEquipment && activeNavEquipment.equipmentType) {
            handleDisplayUnitChange(null, activeNavEquipment.equipmentType);
        }
    }, [equipmentTypes]);

    const filterSensorTypes = sensorTypeIds => {
        let filteredSensor = sensorTypes[0].items.filter(c => sensorTypeIds.has(c.id));
        setFilteredSensorTypes([{items: Array.from(filteredSensor)}]);
    };

    useEffect(() => {
        if (entitySensors.spaceAirSensors && entitySensors.spaceAirSensors.length > 0 ) {
            setEsensors(entitySensors.spaceAirSensors.map(c => ({
                id:   c.sensorid,
                name: c.sensorName
            })));
        }
        else {
            setEsensors([]);
        }
    }, [entitySensors]);

    useEffect(() => {
        if ( activeNavEquipment && activeNavEquipment.id && sensorTypes && sensorTypes.length > 0) {
            let sensorTypeIds = new Set();
            if ( activeNavEquipment.extendedData && activeNavEquipment.extendedData.sensors) {
                for (let sensor of activeNavEquipment.extendedData.sensors) {
                    sensorTypeIds.add(sensor.sensorTypeId);
                }
            }
           
            filterSensorTypes(sensorTypeIds);
        }
    }, [sensorTypes]);

    useEffect(() => {
        const init = async () => {
            let promises = [];
            if (queryValues.system) {
                promises.push(fetchSensorCalculations({ systemId: queryValues.system }));
            } else {
                promises.push(fetchSensorCalculations({ equipmentId: queryValues.equipment }));
            }
            promises.push(fetchSensorTypes());
            promises.push(fetchEquipmentTypesLookup());
            Promise.all(promises.map(p => p.catch(err => err)));
        };

        if (activeNavCompany.id) init();
    }, [activeNavCompany]);

    useEffect(() => {
        const orderedSensorList = [];
        if (sensorTemplate && sensorTemplate.length > 0 && activeTemplate && activeTemplate.formulaCode) {
            const tempSelectedSensorTemplate = cloneDeep(sensorTemplate);
            let ids = getIds(activeTemplate.formulaCode);
            if (ids && ids.length > 0) {
                for (let sensor of tempSelectedSensorTemplate) {
                    const equipmentSensors = cloneDeep(sensor.sensorType[0].sensor);
                    activeTemplate.sensors.forEach(atSensor => {
                        if (atSensor.isExternalSensor) {
                            if (!sensor.orderedSensors) {
                                const type = [{
                                    id:               atSensor.id,
                                    name:             atSensor.name,
                                    isExternalSensor: true,
                                    sensor:           [
                                        {
                                            id:           '-2',
                                            name:         'Add External Sensor',
                                            sensorTypeId: atSensor.id
                                        }
                                    ]

                                }];
                                sensor.orderedSensors = type;
                            }
                            else {
                                sensor.orderedSensors.push({
                                    id:               atSensor.id,
                                    name:             atSensor.name,
                                    isExternalSensor: true,
                                    sensor:           [
                                        {
                                            id:           '-2',
                                            name:         'Add External Sensor',
                                            sensorTypeId: atSensor.id
                                        }
                                    ]

                                });
                            }
                        }
                        else {
                            const sensorType = sensorTemplate[0].sensorType.filter(st => st.id === atSensor.id);
                            if (!sensor.orderedSensors) {
                                const type = [{
                                    id:               atSensor.id,
                                    name:             atSensor.name,
                                    isExternalSensor: false,
                                    sensor:           equipmentSensors
                                }];
                                sensor.orderedSensors = type;
                            }
                            else {
                                sensor.orderedSensors.push({
                                    id:               atSensor.id,
                                    name:             atSensor.name,
                                    isExternalSensor: false,
                                    sensor:           equipmentSensors
                                });
                            }
                        }
                    });
                    sensor.sensorType = sensor.orderedSensors;
                    if (sensor.sensorType && sensor.sensorType.length > 0 && (ids.length > sensor.sensorType.length)) {
                        let sts = [];
                        for (let _id of ids) {
                            let tp = sensor.sensorType.find(c => c.id === _id);
                            if (tp) {
                                sts.push(JSON.parse(JSON.stringify(tp)));
                            }
                        }
                        sensor.sensorType = sts;
                    }
                }
            }

            for (let sensor1 of tempSelectedSensorTemplate) {
                sensor1.disabled = false;
                sensor1.status = sensor1.assigned ? 'Assigned' : 'Unassigned';
                sensor1.sensorName = activeTemplate.name;
                for (let st of sensor1.sensorType) {
                    if (st.sensor && st.sensor.length === 1) {
                        if ( st.sensor[0].id === '-2') {
                            st.sensor.unshift({id: '-1', name: 'Select Sensor'});
                        }
                        st.selectedSensor = st.sensor[0];
                    }
                    else if ( st.sensor && st.sensor.length > 1) {
                        if (st.sensor[0].id !== '-1') {
                            st.sensor.unshift({id: '-1', name: 'Select Sensor'});
                        }
                        st.selectedSensor = st.sensor[0];
                    }
                    else  {
                        st.selectedSensor = null;
                    }
                    if (!(st.sensor && st.sensor.length > 0)) {
                        sensor1.disabled = true;
                    }
                }               
            }
            let obj  = extractConstants(activeTemplate.formulaCode);
            if (obj.constants && obj.constants.length > 0) {
                tempSelectedSensorTemplate.forEach(c => {
                    c.constants = JSON.parse(JSON.stringify(obj.constants));
                });
            }
            obj.displayToken = insertTemplateTokens(obj.displayToken);
            setDisplayToken(obj.displayToken);
            setSensorList(tempSelectedSensorTemplate);
            setSensorListBase([...tempSelectedSensorTemplate]);
            let rt = [];
            for (let sf of tempSelectedSensorTemplate) {
                rt.push(sf.disabled);
            }
            setCheckedList(rt);
            setSelectedSensorTemplate(tempSelectedSensorTemplate);
           
        }
    }, [sensorTemplate]);

    // useEffect(() => {
    //     // const init = async () => {
    //     if (moment(dashboardBulkComplete).isSameOrAfter(moment(bulkCreateSubmittedTime))) {
    //         // redirect to the sensor overview page
    //         let path = '/v2/dashboard/';
    //         if (history.location?.state?.entityType) {
    //             const { entityType, entityId } = history.location.state;
    //             const queryValues = queryString.parse(history.location.search);
    //             switch (history.location.state.entityType) {
    //                 case 'equipment':
    //                     path += 'equipment';
    //                     break;
    //                 case 'system':
    //                     path += 'system';
    //                     break;
    //                 default:
    //                     path += 'equipment';
    //                     break;
    //             }
    //             queryValues.equipmentId = entityId;
    //             queryValues.parentId = '7a88bd3d-64e3-4af9-aa06-9a31533df83c';
    //             queryValues.childId = '4b25aeb8-75d4-4522-9f77-870ab40abb07';
    //             queryValues.viewChildId = '4b25aeb8-61d4-4522-9f77-870ab40abb07';
    //             const queryValuesString = queryString.stringify(queryValues);
    //             history.push(`${path}?${queryValuesString}`);
    //         }
    //     }
    //     //        };
    //     // init();
    // }, [dashboardBulkComplete]);

    const formik = useFormik(formVal);

    const handleClear = () => {
        let val = false;
        let vals = filteredEquipments;
        for (let c of vals) {
            c.checked = val;
        }
        setFilteredEquipments(JSON.parse(JSON.stringify(vals)));
        setSelectAll(val);
        setSensorList([]);
        setSensorListBase([]);
    };

    const handleBackClick = () => {
        setEditorVisible(false);
    };

    const getUnit = unitId => {
        let targetUnit;

        units.forEach(unit => {
            unit.items.forEach(item => {
                if (item.id === unitId) {
                    targetUnit = { ...item };
                }
            });
        });

        return targetUnit;
    };

    const handleDisplayUnitChange = (event,value) => {
        let key = value ? value.id : '';
        formik.setFieldValue('equipmentType', key, true);
        formik.setFieldValue('equipmentTypeSelected', value, true);
        fetchEquipments(key);
    };

    useEffect(() => {
        let eq = equipment.filter(c => c.equipmentType.id ===formik.values.equipmentType);
        setFilteredEquipments(eq);
    }, [equipment]);

    const fetchEquipments = async (equipmentTypeId) => {
        await fetchCoreEquipment(activeNavCompany.id, { equipmentTypeId: equipmentTypeId });
    };

    const handleUnitChange = event => {
        formik.handleChange(event);
        let displayUnits;

        formik.setFieldValue('displayUnit', event.target.value);
    };

    const handleTestConfirmation = () => {
    
    };

    const handleChange = (e, i) => {
        let vals = filteredEquipments;
        vals[i].checked = e.target.checked;
        if (e.target.checked === false) {
            setSelectAll(false);
        }
        setFilteredEquipments([...vals]);
    };

    const handleSensorChange = (e, i) => {  
        let vals = sensorList;
        vals[i].checked = e.target.checked;
        if (!e.target.checked) {
            setSelectAllV(false);
        }
        setSensorList([...vals]);
        setSensorListBase([...vals]);
    };

    const handleSelectAllV = (e, i) => {  
        let vals = sensorList;
        for (let [i, val] of vals.entries()) {
            if (!checkedList[i]) {
                vals[i].checked = e.target.checked;
            }
        }
        setSelectAllV(e.target.checked);
        setSensorList([...vals]);
        setSensorListBase([...vals]);
    };

    const handleSensorSelect = (e, i, j) => {

        const init = async () => {
            let promises = [];
            promises.push(fetchEntitySensors(sensorList[i].siteDetails.id, sensorList[i].id));
            Promise.all(promises.map(p => p.catch(err => err)));
        };

        if (e.target.value && e.target.value.id === '-2') {
            const type = sensorList[i].sensorType.find(t => t.id === e.target.value.sensorTypeId);
            extSensorIndex.current = i + '_' + j;
            setExternalSensorOpen(true);
            setActiveSite();
            formik.setFieldValue('sensorType1', type, true);
        }
        else {
            let vals = sensorList;
            let checledlst = checkedList;
            vals[i].sensorType[j].selectedSensor = e.target.value;
            let disabled = false;
            for (let cf of vals[i].sensorType) {
                if (cf.selectedSensor.id === '-1') {
                    disabled = true;
                }
            }
            vals[i].disabled = disabled;
            if (disabled) {
                vals[i].checked = false;
            }
            checledlst[i] = disabled;
            setCheckedList([...checledlst]);
            setSensorList([...vals]);
        }
    };

    const handleStatusSensorSelect = (e, i) => {
        let vals = sensorList;
        vals[i].status = e.target.value;
        setSensorList(vals);
        setSensorListBase([...vals]);
    };

    const handleStatusSensoName = (e, i) => {
        let vals = sensorList;
        vals[i].sensorName = e.target.value;
        setSensorList([...vals]);
        setSensorListBase([...vals]);
    };

    const handleConstantVal = (e, i, j) => {
        let vals = sensorList;
        vals[i].constants[j].val = e.target.value;
        setSensorList([...vals]);
        setSensorListBase([...vals]);
    };

    const handleWorkbookMode = () => {
        handleClick2();
        handleClickClient();
        handleClickClient3();
        setWorkBookMode(!workbookModeEnabled);
    };

    const handleSelectAll = (e, i) => {
        let val = e.target.checked;
        let vals = filteredEquipments;
        for (let c of vals) {
            c.checked = val;
        }
        setFilteredEquipments(JSON.parse(JSON.stringify(vals)));
        setSelectAll(val);
    };

    const handleTemplateChange = (event, activeTemplate) => {
        let key = activeTemplate;
        formik.setFieldValue('template', key, true);
        if (activeTemplate && activeTemplate.id) {
            formik.setFieldValue('name', activeTemplate.name);
            formik.setFieldTouched('name', true);
            activeTemplate.formulaText = insertTemplateTokens(activeTemplate.formulaCode);
            setActiveTemplate(activeTemplate);
            if (sensorTypes && sensorTypes.length > 0) {
                let sensorType = sensorTypes[0].items.find(c => c.id === activeTemplate.sensorTypeId);
                if (sensorType) {
                    formik.setFieldValue('sensorType', sensorType);
                    formik.setFieldTouched('sensorType', true);
                }
                let unit = units.find(c => c.items[0].id ===activeTemplate.rawUnitId);

                formik.setFieldValue('unit', getUnit(activeTemplate.rawUnitId));
                formik.setFieldValue('displayUnit', getUnit(activeTemplate.rawUnitId));
                formik.setFieldTouched('unit', true);
                formik.setFieldValue('displayDataType', activeTemplate.outputDataType.charAt(0).toUpperCase() + activeTemplate.outputDataType.slice(1));
                formik.setFieldTouched('displayDataType', true);
            }
        }
    };
    const getPleaseChooseTemplate= (d) => {
        return '&nbsp;<span data-ui-variable="'+ d.id + '" class="variable-token please-choose-sensor">' + d.name + '</span>&nbsp;';
    };

    const isSafari  = () =>{
        var is_safari = navigator.userAgent.toLowerCase().indexOf('safari') > -1;
        return is_safari;
    };

    const printSubsInDelimiters = (str) => {
        let data = [];
        // Stores the indices of
        let dels = [];
        for (let i = 0; i < str.length; i++) {
 
            // If opening delimiter
            // is encountered
            if (str[i] === '[')
            {
                dels.push(i);
            }
 
            // If closing delimiter
            // is encountered
            else if ((str[i] === ']') &&
                     (dels.length > 0))
            {
 
                // Extract the position
                // of opening delimiter
                let pos = dels[dels.length - 1];
 
                dels.pop();
 
                // Length of substring
                let len = i - 1 - pos;
 
                // Extract the substring
                let ans;
                ans = str.substring(pos + 1,
                    len + pos + 1);
                data.push(ans);
            }
        }
        return data;
    };

    const insertTemplateTokens = token => {
        let template = token;
        template = template.replace(/\u00A0/g, '');
        let offset = 1;
        let matches = printSubsInDelimiters(template);
        if (matches && matches.length>0) {
            matches = matches.map(c => c.trim()).map(c => c.substring(offset, c.length - offset));
            matches = Array.from(new Set(matches));
            for (let d of matches) {
                const selectedId = d;
                if (selectedId !== '' && sensorTypes && sensorTypes.length > 0 ) {
                    const sensor = sensorTypes[0].items.find(sensor => sensor.id === selectedId);
                    template = template.replaceAll(d, sensor.name);
                }
            }
        }
        return template.replace('return ','');
    };

    const extractConstants = (token) => {
        let scope = {
            1:  'A',
            2:  'B',
            3:  'C',
            4:  'D',
            5:  'E',
            6:  'F',
            7:  'G',
            8:  'H',
            9:  'I',
            10: 'J',
            11: 'K',
            12: 'L',
            13: 'M',
            14: 'N',
            15: 'O',
            16: 'P',
            17: 'Q',
            18: 'R',
            19: 'S',
            20: 'T',
            21: 'U',
            22: 'V',
            23: 'W',
            24: 'X',
            25: 'Y',
            26: 'Z'
        };

        let original = token;
        let temp = token;
        let constants = [];
        let matches = temp.match(/\{(.*?)\}/g);
        if (matches && matches.length > 0) {
            matches = matches.map(c => c.trim()).map(c => c.substring(1, c.length - 1));
            matches = Array.from(new Set(matches));
            for (let [i, d] of matches.entries()) {
                let constLbl = 'Constant '+ scope[i + 1];
                constants.push({title: constLbl, val: d});
                original = original.replace('((' + d + '))',constLbl);
            }
        }
        return {displayToken: original, constants: constants };
    };

    
    const openExternalSensorModal = () => {
        extSensor.current = null;
        extSensorIndex.current = null;
        setExternalSensorOpen(true);
        setActiveSite();
    };

    const handleClick1 = event => {
        setAnchorEl1(event.currentTarget);
        setMenuOpen(!menuOpen);
    };
    const handleClick1Client = event => {
        setAnchorEl2(event.currentTarget);
        setMenuOpen2(!menuOpen);
    };

    const handleClick3Client = event => {
        setAnchorEl3(event.currentTarget);
        setMenuOpen3(!menuOpen);
    };

    const handleClick2 = event => {
        setFilterop('');
        setEqFilter('');
    };

    const handleClickClient = event => {
        setFilteropClient('');
        setClientFilter('');
    };

    
    const handleClickClient3 = event => {
        setFilteropSite('');
        setSiteFilter('');
    };


    const handleClose1 = () => {
        setAnchorEl1(null);
        setMenuOpen(false);
    };

    const handleClose2 = () => {
        setAnchorEl2(null);
        setMenuOpen2(false);
    };

    const handleClose3 = () => {
        setAnchorEl3(null);
        setMenuOpen3(false);
    };


    const handleSelect1 = (e) => {
        setAnchorEl1(null);
        setMenuOpen(false);
        setFilterop(e);
    };

    const handleSelect2 = (e) => {
        setAnchorEl2(null);
        setMenuOpen2(false);
        setFilteropClient(e);
    };

    const handleSelect3 = (e) => {
        setAnchorEl3(null);
        setMenuOpen3(false);
        setFilteropSite(e);
    };

    const handleClick = event => {
        setAnchorEl(event.currentTarget);
    };

    const handleSiteChange = event => {
        formik.handleChange(event);
        formik.setFieldValue('site', event.target.value, false);
        loadSites(event.target.value);
    };

    const setActiveSite = () => {
        const init = async () => {
            await fetchConfigEntitesBySiteId(activeNavSite.id, {extendedData: true, page: 1, limit: 1000 });
        };
      
        if (formik.values.site !== activeNavSite.id ) {
            formik.setFieldValue('site', activeNavSite.id, false);
            if (activeNavSite.id) init();
        }
    };

    const loadSites = async site => {
        await fetchConfigEntitesBySiteId(site, {extendedData: true, page: 1, limit: 1000 });
    };

    useEffect(() => {
        const init = async () => {
            await fetchConfigEntitesBySiteId(activeNavSite.id, {extendedData: true, page: 1, limit: 1000 });
        };

        if (activeNavSite.id) init();
    }, [activeNavSite]);

    useEffect(() => {
        const entities = [...configEntities];
        setEntities(entities);
    }, [configEntities]);

    const filterEntities = async value => {
        setLoading(true);
        if (!isEmpty(value)) {
            await fetchConfigEntitesBySiteId(activeNavSite.id, { searchFilter: value, extendedData: true, page: 1, limit: 1000 });
        } else {
            await fetchConfigEntitesBySiteId(activeNavSite.id, {extendedData: true, page: 1, limit: 1000 });
        }
        setLoading(false);
    };
        
    const clearSearch = () => {
        setAutoCompleteValue('');
    };

    const externalsensorClicked = (id, item, className) => {
    };

    const setExternalSensor = (i, j) => {
        let vals = sensorList;
        let checledlst = checkedList;
        vals[i].sensorType[j].selectedSensor = extSensor.current;
        vals[i].sensorType[j].sensor.push(extSensor.current);
        let disabled = false;
        for (let cf of vals[i].sensorType) {
            if (cf.selectedSensor && cf.selectedSensor.id === '-1') {
                disabled = true;
            }
        }
        vals[i].disabled = disabled;
        if (disabled) {
            vals[i].checked = false;
        }
        checledlst[i] = disabled;
        setCheckedList([...checledlst]);
        setSensorList([...vals]);
        setSensorListBase([...vals]);
    };

    const submitFormula = () => {
        setExternalSensorOpen(false);
        if (extSensorIndex.current) {
            setExternalSensor(+extSensorIndex.current.split('_')[0], +extSensorIndex.current.split('_')[1]);
        }
    };

    const debouncedFetch = useCallback(
        debounce(value => {
            filterEntities(value);
        }, 700),
        []
    );

    const filterSensorTypesR = (eq) => {
        if ( eq && eq.id && sensorTypes && sensorTypes.length > 0) {
            let sensorTypeIds = new Set();
            if ( eq.extendedData && eq.extendedData.sensors) {
                for (let sensor of eq.extendedData.sensors) {
                    sensorTypeIds.add(sensor.sensorTypeId);
                }
            }
           
            let filteredSensor = sensorTypes[0].items.filter(c => sensorTypeIds.has(c.id));
            setFilteredExtSensorTypes([{items: Array.from(filteredSensor)}]);
        }
    };

    const handleEntityChange = item => {
        const init = async (item) => {
            if (formik.values.sensorType1 && formik.values.sensorType1.id) {
                let promises = [];
                promises.push(fetchReportSensorsbyEquipment([item.id], [formik.values.sensorType1.id]));
                Promise.all(promises.map(p => p.catch(err => err)));
            }
        };

        setAutoCompleteValue(item.name);
        setSelectedEntity(item);
        handleClose();
        filterSensorTypesR(item);
        formik.setFieldValue('sensor', null, true);
        init(item);
    };

    const handleConfirmation = () => {
        setExternalSensorOpen(false);
    };

    const textChange = (e) => {
        let data = e.target.value;
        setEqFilter(data);

    };

    useEffect(() => {
        filterList();
    }, [siteFilter, clientFilter, eqFilter, filterop, filteropClient, filteropSite]);

    const textChange2 = (e) => {
        let data = e.target.value;
        setClientFilter(data);
    };

    const textChange3 = (e) => {
        let data = e.target.value;
        setSiteFilter(data);
    };

    const filterList = () => {
        if (filterTimer) {
            clearTimeout(filterTimer);
        }
        filterTimer = setTimeout(() => {
            filterSensors();
        }, 300);
    };

    const filterSensors = () =>{
        //Does not Contain','Is equal to','Is not equal to','Starts with','Ends with','Is null','Is not null','Is empty','Is not empty'
        let sList = sensorListBase;
        let newList = [];
        let filterted = false;
        let op;
        let searchKey ;
        if (eqFilter) {
            searchKey = eqFilter;
            op = filterop;
            filterted = true;
            if (!op || op === 'Contains') {
                newList = sList.filter(c => c['name'].toLowerCase().indexOf(searchKey.toLowerCase()) !== -1) ;
            }
            else if (op === 'Does not Contain') {
                newList = sList.filter(c => c['name'].toLowerCase().indexOf(searchKey.toLowerCase()) === -1) ;
            }
            else if (op === 'Is equal to') {
                newList = sList.filter(c => c['name'].toLowerCase() === searchKey.toLowerCase()) ;
            }
            else if (op === 'Is not equal to') {
                newList = sList.filter(c => c['name'].toLowerCase() !== searchKey.toLowerCase()) ;
            }
            else if (op === 'Starts with') {
                newList = sList.filter(c => c['name'].toLowerCase().startsWith(searchKey.toLowerCase())) ;
            }
            else if (op === 'Ends with') {
                newList = sList.filter(c => c['name'].toLowerCase().endsWith(searchKey.toLowerCase())) ;
            }
            else if (op === 'Is null') {
                newList = sList.filter(c => c['name'] === null) ;
            }
            else if (op === 'Is not null') {
                newList = sList.filter(c => c['name'].toLowerCase() !== null) ;
            }
            else if (op === 'Is empty') {
                newList = sList.filter(c => c['name'].toLowerCase() === '') ;
            }
            else if (op === 'Is not empty') {
                newList = sList.filter(c => c['name'].toLowerCase() !== '') ;
            }
            sList = newList;
        }
        if (clientFilter) {
            searchKey = clientFilter;
            op = filteropClient;
            filterted = true;
            if (!op || op === 'Contains') {
                newList = sList.filter(c => c?.clientDetails?.name?.toLowerCase().indexOf(searchKey.toLowerCase()) !== -1) ;
            }
            else if (op === 'Does not Contain') {
                newList = sList.filter(c => c?.clientDetails?.name?.toLowerCase().indexOf(searchKey.toLowerCase()) === -1) ;
            }
            else if (op === 'Is equal to') {
                newList = sList.filter(c => c?.clientDetails?.name?.toLowerCase() === searchKey.toLowerCase()) ;
            }
            else if (op === 'Is not equal to') {
                newList = sList.filter(c => c?.clientDetails?.name?.toLowerCase() !== searchKey.toLowerCase()) ;
            }
            else if (op === 'Starts with') {
                newList = sList.filter(c => c?.clientDetails?.name?.toLowerCase().startsWith(searchKey.toLowerCase())) ;
            }
            else if (op === 'Ends with') {
                newList = sList.filter(c => c?.clientDetails?.name?.toLowerCase().endsWith(searchKey.toLowerCase())) ;
            }
            else if (op === 'Is null') {
                newList = sList.filter(c => c?.clientDetails?.name === null) ;
            }
            else if (op === 'Is not null') {
                newList = sList.filter(c => c?.clientDetails?.name !== null) ;
            }
            else if (op === 'Is empty') {
                newList = sList.filter(c => c?.clientDetails?.name === '') ;
            }
            else if (op === 'Is not empty') {
                newList = sList.filter(c => c?.clientDetails?.name!== '') ;
            }
            sList = newList;
        }
        if (siteFilter) {
            searchKey = siteFilter;
            op = filteropSite;
            filterted = true;
            if (!op || op === 'Contains') {
                newList = sList.filter(c => c?.siteDetails?.name?.toLowerCase().indexOf(searchKey.toLowerCase()) !== -1) ;
            }
            else if (op === 'Does not Contain') {
                newList = sList.filter(c => c?.siteDetails?.name?.toLowerCase().indexOf(searchKey.toLowerCase()) === -1) ;
            }
            else if (op === 'Is equal to') {
                newList = sList.filter(c => c?.siteDetails?.name?.toLowerCase() === searchKey.toLowerCase()) ;
            }
            else if (op === 'Is not equal to') {
                newList = sList.filter(c => c?.siteDetails?.name?.toLowerCase() !== searchKey.toLowerCase()) ;
            }
            else if (op === 'Starts with') {
                newList = sList.filter(c => c?.siteDetails?.name?.toLowerCase().startsWith(searchKey.toLowerCase())) ;
            }
            else if (op === 'Ends with') {
                newList = sList.filter(c => c?.siteDetails?.name?.toLowerCase().endsWith(searchKey.toLowerCase())) ;
            }
            else if (op === 'Is null') {
                newList = sList.filter(c => c?.siteDetails?.name === null) ;
            }
            else if (op === 'Is not null') {
                newList = sList.filter(c => c?.siteDetails?.name !== null) ;
            }
            else if (op === 'Is empty') {
                newList = sList.filter(c => c?.siteDetails?.name === '') ;
            }
            else if (op === 'Is not empty') {
                newList = sList.filter(c => c?.siteDetails?.name!== '') ;
            }
        }
        if (!filterted) {
            newList =[...sensorListBase];
        }
        if (newList.length === 0 && sensorListBase.length > 0) { 
            newList = [JSON.parse(JSON.stringify(sensorListBase[0]))];
            newList[0].isDummy = true;
        }
        setSensorList(newList);
    };


    const correctSensorOrder = (token, sensors) => {
        let orderedSensors = [];
        let template = token;
        template = template.replace(/\u00A0/g, '');
        let matches = printSubsInDelimiters(template);
        if (matches && matches.length > 0) {
            matches = matches.map(c => c.trim()).map(c => c.substring(1, c.length - 1));
            matches = Array.from(new Set(matches));
            for (let d of matches) {
                const selectedId = d;
                if (selectedId !== '') {
                    const sensor = sensors.find(sensor => sensor.id === selectedId);
                    orderedSensors.push(sensor);
                }
            }
        }
        if (activeTemplate && activeTemplate.sensors) { 
            for (let sr of activeTemplate.sensors) {
                if (sr.isExternalSensor) {
                    const sensor = orderedSensors.find(sensor => sensor && sensor.id === sr.id);
                    if (sensor) {
                        sensor.isExternalSensor = true;
                        sensor.sensor.push(
                            {
                                id:           '-2',
                                name:         'Add External Sensor',
                                sensorTypeId: sensor.id
                            }
                        ) ;
                    }
                }
            }
        }
        for (let i = 0; i < orderedSensors.length; i++) {
            if (orderedSensors[i] === undefined) {
                orderedSensors[i] = {
                    id:     '',
                    name:   '',
                    sensor: []
                };
            }
        }
        return orderedSensors.filter(c => c !== undefined);
    };

    const getIds = token => {
        let template = token;
        template = template.replace(/\u00A0/g, '');
        let matches = printSubsInDelimiters(template);
        if (matches && matches.length > 0) {
            matches = matches.map(c => c.trim()).map(c => c.substring(1, c.length-1));
        }
        return matches;
    };

    const getFormulaCode = (constants) => {
        let formula = displayToken;
        const regex = /\{[A-Za-z0-9]+\}/g;
        const matches = formula.match(regex);

        let updatedFormula = formula;
        if (!isEmpty(matches)) {
            matches.forEach((item, index) => {
                updatedFormula = updatedFormula.replace(item, `{${constants[index].val}}`);
            });
        }

        return replaceConstantBraces(updatedFormula);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'nav-select-popover-sensor' : undefined;

    const replaceConstantBraces = (formula) => {
        const normalizedFormula = formula.toLowerCase();
        if (startsWith(normalizedFormula, 'return')) {
            return formula;
        } else {
            return 'return ' + formula;
        }
    };

    const createSensor = () => {
        if (!formik.values.name) {
            dispatch(enqueueSnackbar('Please select Sensor name', 'error'));
            return;
        }
        if (!(formik.values && formik.values.sensorType && formik.values.sensorType.id)) {
            dispatch(enqueueSnackbar('Please select Sensor Type.', 'error'));
            return;
        }

        if (!(formik.values && formik.values.displayUnit && formik.values.displayUnit.id)) {
            dispatch(enqueueSnackbar('Please select Raw Unit.', 'error'));
            return;
        }

        let postbody = {siteId: activeNavSite ? activeNavSite.id : '', sensors: []};
        for (let sensor of selectedSensorTemplate) {
            if (sensor.checked) {
                let _sensor = {
                    sensorId:            '',
                    name:                sensor.sensorName,
                    sensorTypeId:        formik.values && formik.values.sensorType && formik.values.sensorType.id ? formik.values.sensorType.id: activeTemplate.sensorTypeId,
                    rawUnitId:           formik.values && formik.values.unit.id,
                    presentationUnitId:  formik.values && formik.values.displayUnit.id,
                    equipmentId:         sensor.id,
                    sensorCalculation:   sensor.constants && sensor.constants.length > 0 ? getFormulaCode(sensor.constants) :replaceConstantBraces(activeTemplate.formulaCode),
                    outputDataType:      formik.values && formik.values.displayDataType ? formik.values.displayDataType:activeTemplate.rawUnitId,
                    calculatedSensor:    true,
                    sensorCalculationId: activeTemplate.id,
                    calculatedSensorIds: [],
                    companyId:           activeNavCompany?activeNavCompany.id:''
                };
                
                if (!_sensor.rawUnitId) {
                    dispatch(enqueueSnackbar('Please select Raw Unit.', 'error'));
                    return;
                }

                postbody.sensors.push(_sensor);
                // get the selected sensors in the proper order
                sensor.orderedSensors.forEach(s => {
                    _sensor.calculatedSensorIds.push(s.selectedSensor.id);
                });

                if (!isEmpty(_sensor.calculatedSensorIds)) {
                    const regex = /sensors\["[^"]*"]/g;
                    const matches = _sensor.sensorCalculation.match(regex);
                    if (!isEmpty(matches)) {
                        let updatedFormula = _sensor.sensorCalculation;
                        matches.forEach((item, index) => {
                            updatedFormula = updatedFormula.replace(item, `sensors["${_sensor.calculatedSensorIds[index]}"]`);
                        });
                        _sensor.sensorCalculation = updatedFormula;
                    }
                }
            }
        }
        if (postbody.sensors.length === 0) {
            dispatch(enqueueSnackbar('Please select atleast one sensor', 'error'));
            return;
        }
        setIsLoading(true);
        setBulkCreateSubmittedTime(Math.floor(Date.now() / 1000));
        createBulkSensors(postbody);
    };

    useEffect(() => {
        if (sensorsCreatedEvent && sensorsCreatedEvent >= bulkCreateSubmittedTime) {
            const promises = [collectTargetSensors()];
            Promise.all(promises.map(p => p))
                .then(results => {});
        }
    }, [sensorsCreatedEvent]);

    useEffect(() => {
        setIsLoading(false);
        let sensors = sensorList;
        if (sensors && sensors.length > 0 && sensorErrorObj && sensorErrorObj.data && sensorErrorObj.data.length > 0) {
            for (let hh of sensors) {
                let error = sensorErrorObj.data.find(c => c.equipmentId === hh.id);
                if (error && error.messages && error.messages['database validation'] && error.messages['database validation']['asyncPredicateValidator']) {
                    hh.errorMessage = error.messages['database validation']['asyncPredicateValidator'];
                }
                else  if (error && error.messages && error.messages['bulkSensorProcessor'] && error.messages['bulkSensorProcessor']) {
                    hh.errorMessage = error.messages['bulkSensorProcessor'].Message;
                }
            }
            setSensorList(sensors);
            setSensorListBase([...sensors]);
        }
    }, [sensorErrorObj]);

    const handleApply = () => {
        setEditorVisible(true);
        setSensorList([]);
        setSensorListBase([]);
        let selectedEquipments = filteredEquipments.filter(c => c.checked).map(c => c.id);
        if (selectedEquipments.length === 0) {
            dispatch(enqueueSnackbar('Please select at least 1 equipment', 'error'));
            return;
        }

        if (!formik.values.template) {
            dispatch(enqueueSnackbar('Please select template', 'error'));
            return;
        }
        const option = {
            Id:         formik.values.template.id,
            companyId:  activeNavCompany.id,
            equipments: selectedEquipments
        };
        const save = async () => {
            await fetchSensorTemplate(option);
        };       

        save();
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const  itemChange = (event) => {
    };

    const handleSensorTypeChange = event => {
        const {value} = event.target;

        if (formik.values.name) {
            formik.handleChange(event);
            return;
        }

        formik.setFieldValue('name', value.name, false);
        formik.handleChange(event);
    };

    const handleSensorTypeChange1 = event => {
        formik.setFieldValue('sensorType1', event.target.value, true);
        formik.setFieldValue('sensor', null, true);
        formik.handleChange(event);
    };

    const handleSensorChange1 = event => {
        const {value} = event.target;
        extSensor.current = event.target.value;
        formik.setFieldValue('sensor', event.target.value, true);
        formik.handleChange(event);
    };

    const statusDropDownCell = props => {
        const handleChange = (e) => {
        };

        const keyvalue = props.dataItem[props.field];
        return (
            <td>
                <DropDownList
                    style={{ width: '100px' }}
                    onChange={handleChange}
                    value={keyvalue}
                    data={statusList}
                    valueField="id"
                    textField="name"
                />
            </td>
        );
    };

    const sensorDropDownCell = props => {
        const handleChange = (e) => {
        };

        const keyvalue = props.dataItem[props.field];
        return (
            <td>
                <DropDownList
                    style={{ width: '100px' }}
                    onChange={handleChange}
                    value={keyvalue}
                    data={sensorList}
                    valueField="id"
                    textField="name"
                />
            </td>
        );
    };

    return (
        <React.Fragment>
            <div className={`calculated-sensor calculated-assign ${classes.CalculationContainer}`}>
                <div className={classes.FormulaForm}>
                    <div className={classes.TemplateCol}>
                        <div>Universe</div>
                        <div className={classes.formRow}>
                            <FormControl className={classes.inputWrapper} style={{ width: 180 }}>
                                <AutoComplete
                                    label="Templates"
                                    name="template"
                                    onBlur={formik.handleBlur}
                                    onChange={handleTemplateChange}
                                    getOptionLabel={(option) => option.name || ''}
                                    getOptionSelected={(option, value) => option && value ? option.name === value.name : ''}
                                    options={sensorCalculations?sensorCalculations:[]}
                                    error={Boolean(formik.errors.template) && Boolean(formik.touched.template)}
                                    helperText={Boolean(formik.errors.template) && Boolean(formik.touched.template) ? formik.errors.template : null}
                                    placeholder="Template"
                                    size="small"
                                    required  
                                    renderInput={(params) => <TextField {...params} label="Template" />}
                                />
                            </FormControl>
                        </div>
                        <div style={{marginTop: 15}} className={classes.formRow}>
                            {
                                <FormControl className={classes.inputWrapper} style={{ width: 180 }}>
                                    <AutoComplete
                                        label="Equipment Type"
                                        name="equipmentType"
                                        onBlur={formik.handleBlur}
                                        onChange={(event, value) => handleDisplayUnitChange(event, value)}
                                        getOptionLabel={(option) => option.name || ''}
                                        getOptionSelected={(option, value) => option && value ? option.name === value.name : ''}
                                        value={formik.values.equipmentTypeSelected}
                                        options={equipment1Types}
                                        error={Boolean(formik.errors.equipmentType) && Boolean(formik.touched.equipmentType)}
                                        helperText={Boolean(formik.errors.equipmentType) && Boolean(formik.touched.equipmentType) ? formik.errors.equipmentType : null}
                                        placeholder="Equipment Type"
                                        size="small"
                                        required  
                                        renderInput={(params) => <TextField {...params} label="Equipment Type" />}
                                    />
                                </FormControl>
                            }
                        </div>
                        <Accordion defaultExpanded={true} style={{marginTop: '15px !important;'}} className={`${classes.AssignAccordion} assign-accordion`}>
                            <AccordionSummary
                                className={classes.accordionSummary}
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <div>
                                    Equipments
                                </div>
                            </AccordionSummary>
                            <AccordionDetails className={classes.AccordionContent}>
                                <p>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                classes={{
                                                    root: classes.Checkbox
                                                }}
                                                label={'Select All'}
                                                name=""
                                                checked={selectAll}
                                                onChange={handleSelectAll}
                                            />
                                        }
                                    /><p className="select-all-assign">Select All </p>
                                </p>
                                {filteredEquipments && filteredEquipments.length >0 ?
                                    <p>
                                        {filteredEquipments.map((eq, i) =>
                                            <div style={{marginBottom: 15}}>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            classes={{
                                                                root: classes.Checkbox
                                                            }}
                                                            key={`ter-${i}`}
                                                            checked={eq.checked ? true : false}
                                                            onChange={(e)=>handleChange(e, i)}
                                                        />
                                                    }
                                                />
                                                <div>
                                                    <p>{eq.name}</p>
                                                    {eq.extendedData && eq.extendedData.client && eq.extendedData.client.length >0 ?  <p style={{color: '#7c7c7c',fontSize: 10}}>{eq.extendedData.client[0].name}</p>:''}
                                                    {eq.extendedData && eq.extendedData.site && eq.extendedData.site.length >0 ?  <p style={{color: '#7c7c7c',fontSize: 10}}>{eq.extendedData.site[0].name}</p>:''}
                                                </div>
                                            </div>)}
                                    </p>
                                    : ''}
                            </AccordionDetails>
                        </Accordion>
                        <div className={classes.FormulaButton}>
                            <BobConfirmButton
                                className={classes.Button}
                                style={{marginLeft: 15,float: 'right'}}
                                variant="contained"
                                onClick={handleApply}
                            >
                                Preview Sensor
                            </BobConfirmButton>
                        </div>
                    </div>
                    <div className={classes.TemplateFormulabuilder} >
                        {editorVisible?
                            <>
                                <div className="assign-sensor-template" >
                                    <span>{`Template:-  ${displayToken? displayToken : ''} `}</span>
                                    <div style={{float: 'right', marginTop: -5}} className={classes.WorkbookModeContainer}>
                                        <BobWorkbookModeButton handleWorkbookMode={handleWorkbookMode} workbookMode={workbookModeEnabled} />
                                    </div>
                                </div> 
                                <div className="assign-sensor" style={{ height: 'calc(100vh - 450px)', overflow: 'auto', maxWidth: 'calc( 100vw - 250px)' }}>
                                    <div id="assign-grid-row" className={`${classes.formRow} assign-grid-select`} style={{height: 42}}>
                                        {sensorList && sensorList.length > 0 ?
                                            <p className="MuiFormControl-root assign-check">
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            classes={{
                                                                root: classes.Checkbox
                                                            }}
                                                            label={'Select All'}
                                                            name=""
                                                            checked={selectAllV}
                                                            onChange={handleSelectAllV}
                                                        />
                                                    }
                                                />
                                            </p>
                                            : ''
                                        }
                                    </div>
                                    {sensorList && sensorList.length > 0 ?
                                        <div id="assign-grid-row" style={{height: 30,border: 'none',visibility: workbookModeEnabled ? 'visible' : 'collapse'}}>
                                            <FormControl className={classes.FormControl} style={{ width: 225, marginLeft: 50}}>
                                                <div>
                                                    <TextField
                                                        value={eqFilter} onChange={textChange} label=""   
                                                        style={{float: 'left', width: 145}}
                                                    />
                                                    {filterop || eqFilter ?
                                                        <Button
                                                            className={classes.Button}
                                                            aria-describedby={id}
                                                            style={{float: 'right', minWidth: 30, marginTop: 9}}
                                                            onClick={handleClick2}
                                                        >
                                                            <div className={classes.Selector}>
                                                                <span role="presentation" className="k-button-icon k-icon k-i-filter-clear" />     
                                                            
                                                            </div>
                                                        </Button>
                                                        :
                                                        ''
                                                    }
                                                    <Button
                                                        className={classes.Button}
                                                        aria-describedby={id}
                                                        style={{float: 'right', minWidth: 30}}
                                                        onClick={handleClick1}
                                                    >
                                                        <div className={classes.Selector}>
                                                            <p><span role="presentation" className="k-button-icon k-i-filter k-icon" /></p>
                                                        </div>
                                                    </Button>
                                                    <Popover
                                                        id={id}
                                                        open={menuOpen}
                                                        anchorEl={anchorEl1}
                                                        onClose={handleClose1}
                                                        anchorOrigin={{
                                                            vertical:   'bottom',
                                                            horizontal: 'right',
                                                        }}
                                                        transformOrigin={{
                                                            vertical:   'top',
                                                            horizontal: 'right',
                                                        }}
                                                    >
                                                        <div>
                                                            <List>
                                                                {operatorList.map((c, index) => 
                                                                    <ListItem
                                                                        key={index}
                                                                        onClick={() => handleSelect1(c)}
                                                                        style={{cursor: 'pointer'}}
                                                                        classes={{
                                                                            root: classes.ListItem
                                                                        }}
                                                                    >
                                                                        {c}
                                                                    </ListItem>
                                                                )}
                                                            </List>
                                                        </div>
                                                    </Popover>
                                                </div>
                                            </FormControl>
                                            <FormControl className={classes.FormControl} style={{ width: 225, marginLeft: 160}}>
                                                <div>
                                                    <TextField
                                                        value={clientFilter} 
                                                        onChange={textChange2} 
                                                        label=""   
                                                        style={{float: 'left', width: 145}}
                                                    />
                                                    {filteropClient || clientFilter ?
                                                        <Button
                                                            className={classes.Button}
                                                            aria-describedby={id}
                                                            style={{float: 'right', minWidth: 30, marginTop: 9}}
                                                            onClick={handleClickClient}
                                                        >
                                                            <div className={classes.Selector}>
                                                                <span role="presentation" className="k-button-icon k-icon k-i-filter-clear" />     
                                                            </div>
                                                        </Button>
                                                        :
                                                        ''
                                                    }
                                                    <Button
                                                        className={classes.Button}
                                                        aria-describedby={id}
                                                        style={{float: 'right', minWidth: 30}}
                                                        onClick={handleClick1Client}
                                                    >
                                                        <div className={classes.Selector}>
                                                            <p><span role="presentation" className="k-button-icon k-i-filter k-icon" /></p>
                                                        </div>
                                                    </Button>
                                                    <Popover
                                                        id={id}
                                                        open={menuOpen2}
                                                        anchorEl={anchorEl2}
                                                        onClose={handleClose2}
                                                        anchorOrigin={{
                                                            vertical:   'bottom',
                                                            horizontal: 'right',
                                                        }}
                                                        transformOrigin={{
                                                            vertical:   'top',
                                                            horizontal: 'right',
                                                        }}
                                                    >
                                                        <div>
                                                            <List>
                                                                {operatorList.map((c, index) => 
                                                                    <ListItem
                                                                        key={index}
                                                                        onClick={() => handleSelect2(c)}
                                                                        style={{cursor: 'pointer'}}
                                                                        classes={{
                                                                            root: classes.ListItem
                                                                        }}
                                                                    >
                                                                        {c}
                                                                    </ListItem>
                                                                )}
                                                            </List>
                                                        </div>
                                                    </Popover>
                                                </div>
                                            </FormControl>
                                            <FormControl className={classes.FormControl} style={{width: 225}}>
                                                <div>
                                                    <TextField
                                                        value={siteFilter} 
                                                        onChange={textChange3} 
                                                        label=""   
                                                        style={{float: 'left', width: 145}}
                                                    />
                                                    {filteropSite || siteFilter ?
                                                        <Button
                                                            className={classes.Button}
                                                            aria-describedby={id}
                                                            style={{float: 'right', minWidth: 30, marginTop: 9}}
                                                            onClick={handleClickClient3}
                                                        >
                                                            <div className={classes.Selector}>
                                                                <span role="presentation" className="k-button-icon k-icon k-i-filter-clear" />     
                                                            </div>
                                                        </Button>
                                                        :
                                                        ''
                                                    }
                                                    <Button
                                                        className={classes.Button}
                                                        aria-describedby={id}
                                                        style={{float: 'right', minWidth: 30}}
                                                        onClick={handleClick3Client}
                                                    >
                                                        <div className={classes.Selector}>
                                                            <p><span role="presentation" className="k-button-icon k-i-filter k-icon" /></p>
                                                        </div>
                                                    </Button>
                                                    <Popover
                                                        id={id}
                                                        open={menuOpen3}
                                                        anchorEl={anchorEl3}
                                                        onClose={handleClose3}
                                                        anchorOrigin={{
                                                            vertical:   'bottom',
                                                            horizontal: 'right',
                                                        }}
                                                        transformOrigin={{
                                                            vertical:   'top',
                                                            horizontal: 'right',
                                                        }}
                                                    >
                                                        <div>
                                                            <List>
                                                                {operatorList.map((c, index) => 
                                                                    <ListItem
                                                                        key={index}
                                                                        onClick={() => handleSelect3(c)}
                                                                        style={{cursor: 'pointer'}}
                                                                        classes={{
                                                                            root: classes.ListItem
                                                                        }}
                                                                    >
                                                                        {c}
                                                                    </ListItem>
                                                                )}
                                                            </List>
                                                        </div>
                                                    </Popover>
                                                </div>
                                            </FormControl>
                                        </div>
                                        :''
                                    }
                                    {sensorList && sensorList.length > 0 ? <React.Fragment>{sensorList.map((item, sesnorIndex) => <div id="assign-grid-row" className={`${classes.formRow} dummy-${item.isDummy}`}>
                                        {sesnorIndex === 0 ? <span className="border-element" /> : ''}
                                        <><React.Fragment>
                                            <p className="MuiFormControl-root assign-check" style={sesnorIndex === 0 ? { marginTop: 15 } : {}}>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            classes={{
                                                                root: classes.Checkbox
                                                            }}
                                                            name=""
                                                            disabled={checkedList[sesnorIndex]}
                                                            key={sesnorIndex}
                                                            checked={item.checked ? true : false}
                                                            onChange={(e) => handleSensorChange(e, sesnorIndex)}
                                                        />}
                                                />
                                            </p>
                                            {item.errorMessage ? <span title={item.errorMessage}><ErrorOutlineIcon className={classes.warningIcon} /></span> : ''}
                                            <span className="assign-sensor-hide1" key={`eq- ${sesnorIndex}`}>
                                                {<FormControl key={sesnorIndex} className={classes.FormControl}>
                                                    <DropDownList
                                                        className={`${classes.Spacing} k-text-disabled`}
                                                        onChange={null}
                                                        label={sesnorIndex === 0 ? 'Equipment' : ''}
                                                        value={item}
                                                        disabled={true}
                                                        data={[]}
                                                        valueField="id"
                                                        textField="name"
                                                    />
                                                </FormControl>}
                                            </span>
                                            <span>
                                                <FormControl className={`assign-sensor-hide ${classes.userInputWrapper}`}>
                                                    <TextField
                                                        id="name"
                                                        name="name"
                                                        type="text"
                                                        value={item.sensorName}
                                                        label={sesnorIndex === 0 ? 'Sensor Name' : ''}
                                                        onChange={(e) => handleStatusSensoName(e, sesnorIndex)}
                                                        InputLabelProps={{
                                                            classes: {
                                                                error:   classes.error,
                                                                focused: classes.labelFocused,
                                                                root:    classes.label
                                                            }
                                                        }}
                                                        inputProps={{ maxLength: 250 }}
                                                    />
                                                </FormControl>
                                            </span>
                                            <span className="assign-sensor-hide1" key={`eq12- ${sesnorIndex}`}>
                                                {<FormControl key={sesnorIndex} className={classes.FormControl}>
                                                    <DropDownList
                                                        className={`${classes.Spacing} k-text-disabled`}
                                                        onChange={null}
                                                        label={sesnorIndex === 0 ? 'Client name' : ''}
                                                        value={item.clientDetails}
                                                        disabled={true}
                                                        data={[]}
                                                        valueField="id"
                                                        textField="name"
                                                    />
                                                </FormControl>
                                                }
                                            </span>
                                            <span className="assign-sensor-hide1" key={`eq56- ${sesnorIndex}`}>
                                                {<FormControl key={sesnorIndex} className={classes.FormControl}>
                                                    <DropDownList
                                                        className={`${classes.Spacing} k-text-disabled`}
                                                        onChange={null}
                                                        label={sesnorIndex === 0 ? 'Site name' : ''}
                                                        value={item.siteDetails}
                                                        disabled={true}
                                                        data={[]}
                                                        valueField="id"
                                                        textField="name"
                                                    />
                                                </FormControl>}
                                            </span>
                                        </React.Fragment><span key={sesnorIndex}>
                                            {
                                                item.sensorType.map((st, index1) => 
                                                    <FormControl key={index1} className={classes.FormControl}>
                                                        <span 
                                                            style={{ fontSize: 12, marginTop: -45 }} 
                                                            className={ st.sensor && st.sensor.length > 0 ? 'k-label' : 'k-label k-text-disabled'} 
                                                        >
                                                            { sesnorIndex === 0 ? `${ st.name } ${ st.isExternalSensor ? '*' : '' }` : '' }</span>
                                                        <DropDownList
                                                            className={`dropdown-assign-pec ${classes.Spacing} ${st.sensor && st.sensor.length > 0 ? '' : 'k-text-disabled'}`}
                                                            onChange={(e) => handleSensorSelect(e, sesnorIndex, index1)}
                                                            defaultValue={st.selectedSensor}
                                                            disabled={st.sensor && st.sensor.length > 0 ? false : true}
                                                            value={st.selectedSensor}
                                                            key={`sta${sesnorIndex}-${index1}`}
                                                            data={st.sensor}
                                                            dataItemKey="id"
                                                            textField="name"
                                                        />
                                                    </FormControl>
                                                )}
                                        </span></>
                                        {item.constants && item.constants.length > 0 ?
                                            <span key={sesnorIndex}>
                                                { item.constants.map((st2, index3) => <FormControl className={`assign-sensor-hide ${classes.userInputWrapper}`}>
                                                    <TextField
                                                        id="name"
                                                        name="name"
                                                        type="text"
                                                        value={st2.val}
                                                        label={sesnorIndex === 0 ? st2.title : ''}
                                                        onChange={(e) => handleConstantVal(e, sesnorIndex,index3)}
                                                        InputLabelProps={{
                                                            classes: {
                                                                error:   classes.error,
                                                                focused: classes.labelFocused,
                                                                root:    classes.label
                                                            }
                                                        }}
                                                        inputProps={{ maxLength: 250 }}
                                                    />
                                                </FormControl>
                                                )}
                                            </span>
                                            :''
                                        }
                                    </div>
                                    )}
                                    </React.Fragment> : ''}
                                </div></>
                            :  
                            <NoSelectedSensorsScreen
                                style={{
                                    width:      '80%',
                                    margin:     '0',
                                    marginLeft: '1rem',
                                    borderLeft: '1px solid #eeeff0'
                                }}
                                message="Please select template and equipment(s) to continue."
                                height={'calc(100vh - 275px)'}
                            />
                        }
                        {editorVisible?
                            <div className={classes.inputs} >
                                <div className={classes.formRow}>
                                    <FormControl className={classes.userInputWrapper} style={{ width: 415, marginLeft: 15 }}>
                                        <AutoComplete1
                                            grouped
                                            label={<React.Fragment><span>Sensor Type</span><span className={classes.Required}> *</span></React.Fragment>}
                                            name="sensorType"
                                            onBlur={formik.handleBlur}
                                            onChange={handleSensorTypeChange}
                                            options={sensorTypes}
                                            placeholder="Sensor Type"
                                            value={formik.values.sensorType}
                                            error={Boolean(formik.errors.sensorType) && Boolean(formik.touched.sensorType)}
                                            helperText={Boolean(formik.touched.sensorType) && formik.errors.sensorType}
                                        />
                                    </FormControl>
                                </div>
                                <div className={classes.formRow} style={{ marginBottom: 15 }}>
                                    <FormControl className={classes.inputWrapper} style={{ width: 200, marginLeft: 15 }}>
                                        <InputLabel
                                            htmlFor="deviceObject"
                                            classes={{
                                                error:   classes.Error,
                                                focused: classes.LabelFocused,
                                                root:    classes.Label
                                            }}
                                            error={Boolean(formik.errors.deviceObject) && Boolean(formik.touched.deviceObject)}
                                        >
                                            Data Type<span className={classes.Required}> *</span>
                                        </InputLabel>
                                        <Select
                                            value={formik.values.displayDataType}
                                            onChange={formik.handleChange}
                                            className={classes.Select}
                                            inputProps={{
                                                name:   'displayDataType',
                                                id:     'displayDataType',
                                                onBlur: formik.handleBlur
                                            }}
                                            error={Boolean(formik.errors.displayDataType) && Boolean(formik.touched.displayDataType)}
                                        >
                                            {
                                                displayDataTypes.map(objectItem =>
                                                    <MenuItem
                                                        key={objectItem}
                                                        value={objectItem}
                                                    >
                                                        {objectItem}
                                                    </MenuItem>
                                                )
                                            }
                                        </Select>
                                    </FormControl>
                                    <FormControl className={classes.inputWrapper} style={{ width: 200, marginLeft: 15 }}>
                                        <InputLabel
                                            htmlFor="deviceObject"
                                            classes={{
                                                error:   classes.Error,
                                                focused: classes.LabelFocused,
                                                root:    classes.Label
                                            }}
                                            error={Boolean(formik.errors.deviceObject) && Boolean(formik.touched.deviceObject)}
                                        >
                                            Display Data Type<span className={classes.Required}> *</span>
                                        </InputLabel>
                                        <Select
                                            value={formik.values.displayDataType}
                                            onChange={formik.handleChange}
                                            className={classes.Select}
                                            inputProps={{
                                                name:   'displayDataType',
                                                id:     'displayDataType',
                                                onBlur: formik.handleBlur
                                            }}
                                            error={Boolean(formik.errors.displayDataType) && Boolean(formik.touched.displayDataType)}
                                        >
                                            {
                                                displayDataTypes.map(objectItem =>
                                                    <MenuItem
                                                        key={objectItem}
                                                        value={objectItem}
                                                    >
                                                        {objectItem}
                                                    </MenuItem>
                                                )
                                            }
                                        </Select>
                                    </FormControl>
                                    <FormControl className={classes.inputWrapper} style={{ width: 200, marginLeft: 25 }}>
                                        <AutoComplete1
                                            grouped
                                            disabled={unitTypeDisabled}
                                            label="Raw Unit"
                                            name="unit"
                                            onBlur={formik.handleBlur}
                                            onChange={handleUnitChange}
                                            options={units}
                                            error={Boolean(formik.errors.unit) && Boolean(formik.touched.unit)}
                                            helperText={Boolean(formik.errors.unit) && Boolean(formik.touched.unit) ? formik.errors.unit : null}
                                            placeholder="Unit"
                                            value={formik.values.unit}
                                        />
                                    </FormControl>
                                    <FormControl className={classes.inputWrapper} style={{ width: 200, marginLeft: 25 }}>
                                        <AutoComplete1
                                            grouped
                                            disabled={displayUnitTypeDisabled}
                                            label="Display Unit"
                                            name="displayUnit"
                                            onBlur={formik.handleBlur}
                                            onChange={handleDisplayUnitChange}
                                            options={displayUnits}
                                            error={Boolean(formik.errors.displayUnit) && Boolean(formik.touched.displayUnit)}
                                            helperText={Boolean(formik.errors.displayUnit) && Boolean(formik.touched.displayUnit) ? formik.errors.displayUnit : null}
                                            placeholder="Display Unit"
                                            value={formik.values.displayUnit}
                                        />
                                    </FormControl>
                                </div>
                            </div> : ''
                        }
                    </div>
                </div>
            </div>
            <div className={classes.ButtonContainer}>
                <BobConfirmButton
                    className={classes.Button}
                    style={{marginLeft: 15,float: 'right'}}
                    variant="contained"
                    onClick={handleClear}
                >
                    Clear
                </BobConfirmButton>  
                <BobConfirmButton
                    className={classes.Button}
                    style={{marginLeft: 15,float: 'right'}}
                    variant="contained"
                    onClick={handleBackClick}
                >
                    Cancel
                </BobConfirmButton>      
                <BobConfirmButton
                    className={classes.ButtonWithMargin} isLoading={isLoading} 
                    onClick={createSensor} label={'Create Sensor'}
                />
            </div>
            {externalSensorOpen?
                <BobModal
                    confirmText="Ok"
                    cancelText="Cancel"
                    rootClass={'external-sensor-modal external-sensor-modal1'}
                    onCancel={handleConfirmation}
                    onClose={handleConfirmation}
                    onConfirm={submitFormula}
                    open={externalSensorOpen}
                    title={'Universe'}
                >
                    <div className={classes1.formRow}>
                        <FormControl className={classes.formRow} style={{ width: '100%', marginBottom: 20, paddingRight: 20 }}>
                            <InputLabel
                                htmlFor="site"
                                classes={{
                                    error:   classes.Error,
                                    focused: classes.LabelFocused,
                                    root:    classes.Label
                                }}
                                error={Boolean(formik.errors.site) && Boolean(formik.touched.site)}
                            >
                                Site<span className={classes.Required}> *</span>
                            </InputLabel>
                            <Select
                                value={formik.values.site}
                                onChange={handleSiteChange}
                                className={classes.Select}
                                error={Boolean(formik.errors.displayDataType) && Boolean(formik.touched.displayDataType)}
                            >
                                {
                                    navSites.map(objectItem =>
                                        <MenuItem
                                            key={objectItem.id}
                                            value={objectItem.id}
                                        >
                                            {objectItem.name}
                                        </MenuItem>
                                    )
                                }
                            </Select>
                        </FormControl>
                    </div>
                    <div style={{marginTop: 20}} className={classes1.formRow}>
                        <TextField
                            id="outlined-basic"
                            label="Equipment/System"
                            variant="outlined"
                            disabled={!activeNavEquipment.id}
                            size="small"
                            value={autoCompleteValue}
                            onChange={e => {
                                setAutoCompleteValue(e.target.value);
                            }}
                            InputProps={{
                                endAdornment: <InputAdornment position="end">{loading ? <CircularProgress size={10} /> : <i onClick={() => clearSearch()} role="none" className={`fas fa-times ${classes1.ClearButton}`} />}</InputAdornment>
                            }}
                            onClick={handleClick}
                            className={classes1.TextField}
                        />
                        <Popper
                            id={id}
                            open={open}
                            anchorEl={anchorEl}
                            onClose={handleClose}
                        >
                            <ClickAwayListener onClickAway={handleClose}>
                                <Paper
                                    className={classes.Popper}
                                    square
                                >
                                    <div className={classes1.List}>
                                        {
                                            !isEmpty(entities) ?
                                                <List>
                                                    {entities.map((item, index) => (
                                                        <ListItem
                                                            key={index}
                                                            onClick={() => handleEntityChange(item)}
                                                            classes={{
                                                                root: classes1.ListItem
                                                            }}
                                                        >
                                                            {item.name}
                                                        </ListItem>
                                                    ))}
                                                </List>
                                                :
                                                <List>
                                                    <ListItem
                                                        key={0}
                                                        classes={{
                                                            root: classes1.ListItem
                                                        }}
                                                    >
                                                        No Equipment or Systems found...
                                                    </ListItem>
                                                </List>
                                        }
                                    </div>
                                </Paper>
                            </ClickAwayListener>
                        </Popper>
                    </div>
                    <FormControl className={classes1.formRow} style={{ width: '100%', marginTop: 20, paddingRight: 20 }}>
                        <AutoComplete1
                            grouped
                            label="Sensor Type"
                            name="sensorType1"
                            onBlur={formik.handleBlur}
                            onChange={handleSensorTypeChange1}
                            options={filteredExtSensorTypes}
                            placeholder="Sensor Type"
                            disabled={true}
                            value={formik.values.sensorType1}
                            error={Boolean(formik.errors.sensorType) && Boolean(formik.touched.sensorType)}
                            helperText={Boolean(formik.touched.sensorType) && formik.errors.sensorType}
                        />
                    </FormControl>
                    <FormControl className={classes1.formRow} style={{ width: '100%', marginTop: 20, paddingRight: 20 }}>
                        <AutoComplete1
                            label="Sensors"
                            name="sensorType2"
                            onBlur={formik.handleBlur}
                            onChange={handleSensorChange1}
                            options={esensors}
                            placeholder="Sensors"
                            value={formik.values.sensor}
                            error={Boolean(formik.errors.sensorType) && Boolean(formik.touched.sensorType)}
                            helperText={Boolean(formik.touched.sensorType) && formik.errors.sensorType}
                        />
                    </FormControl>
                </BobModal>
                : ''
            }
            {
                bobLoading.includes('bulkSensorCreate') ? <BobLoadingMask /> : null
            }
        </React.Fragment>
    );
};

const mapStateToProps = ({ basAgent, ...state }) => {
    const { basAgents } = basAgent;

    return {
        activeNavEquipment:    state.bob.activeNavEquipment,
        activeNavClient:       state.bob.activeNavClient,
        activeNavSite:         state.bob.activeNavSite,
        agents:                Object.values(basAgents),
        bobLoading:            state.bob.bobLoading,
        dashboardBulkComplete: state.wizard.dashboardBulkComplete,
        sensorTypes:           state.sensorTypes.data,
        sensorTemplate:        state.dashboard.sensorTemplate,
        activeNavCompany:      state.bob.activeNavCompany,
        units:                 state.architect.rawUnits,
        equipmentTypes:        state.equipmentTypes.data,
        sensorCalculations:    state.dashboard.sensorCalculations,
        equipment:             state.k2aCore.equipment,
        sensorsCreatedEvent:   state.wizard.sensorsCreatedEvent,
        sensorErrorObj:        state.wizard.sensorErrorObj,
        configEntities:        state.dashboard.configEntities,
        entitySensors:         state.reporting.entitySensors,
        navSites:              state.bob.navSites,
        workbookModeEnabled:   state.dashboard.workbookModeEnabled
    };
};

const mapDispatchToProps = {
    ...BobActions,
    ...DashboardActions,
    ...ArchitectActions,
    ...ApplicationMessageActions,
    ...BasAgentActions,
    ...DeviceActions,
    ...UiActions,
    ...SensorTypeActions,
    ...EquipmentTypeActions,
    ...K2ACoreActions,
    ...WizardActions,
    ...reportingActions,
    fetchEquipmentTypesLookup
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AssignForm));
